import React, { useState } from "react";
import { FiChevronLeft, FiChevronRight, FiDownload } from "react-icons/fi";
import { MdClose } from "react-icons/md";

const ImageModal = ({ isOpen, images, initialIndex, onClose }) => {
  const [currentIndex, setCurrentIndex] = useState(initialIndex || 0);

  if (!isOpen || !images || images.length === 0) return null;

  const handleBackgroundClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? images.length - 1 : prevIndex - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
  };

  const handleDownload = async () => {
    try {
      const response = await fetch(images[currentIndex], { mode: "cors" });
      if (!response.ok) throw new Error("Error al descargar la imagen");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = images[currentIndex].split("/").pop() || "imagen_descargada.jpg";
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
      onClick={handleBackgroundClick} // Manejar clic en el fondo
    >
      <div className="bg-white rounded-lg shadow-lg p-5 relative max-w-4xl w-full">
        {/* Botón de cierre */}
        <div className="mt-2">
          <button
            onClick={onClose}
            className="absolute top-0 right-2 text-gray-700 hover:text-gray-900 text-2xl font-bold"
          >
            <MdClose size={22} />
          </button>
        </div>
        {/* Flechas de navegación */}
        {images.length > 1 && (
          <>
            <button onClick={handlePrev} className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-gray text-white p-2 rounded-full shadow hover:bg-black">
              <FiChevronLeft size={24} />
            </button>
            <button onClick={handleNext} className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-gray text-white p-2 rounded-full shadow hover:bg-black">
              <FiChevronRight size={24} />
            </button>
          </>
        )}
        {/* Imagen */}
        <div className="flex justify-center">
          <img
            src={images[currentIndex]}
            alt="Imagen ampliada"
            className="max-w-full max-h-[80vh] object-contain"
          />
        </div>
        {/* Botón de descarga */}
        <div className="flex justify-end mt-4">
          <button
            onClick={handleDownload}
            className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-800 transition"
          >
            <FiDownload className="mr-2" />
            Descargar imagen
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImageModal;
